//@ts-nocheck

import { IBlock } from "../../../../framework/src/IBlock";
import { Message } from "../../../../framework/src/Message";
import { BlockComponent } from "../../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../../framework/src/RunEngine";
import { RouterProps } from "react-router";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import { withToastProps } from "../../../../components/src/withSnackBar.Web";
import { withLoaderProps } from "../../../../components/src/withLoader.Web";
import { DialogProps } from "../../../../components/src/DialogContext";
export const configJSON = require("../config");

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
    // Customizable Area Start
    // Customizable Area End
  };

interface S {
  // Customizable Area Start
  token: string;
  accountId: any;
  lineChartData: {
    labels: [];
    datasets: [];
  };
  clientList: any[];
  proposalPackagePending: [];
  proposalsSentTimePeriod: number;
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class FirmPerformanceProposalsController extends BlockComponent<
  Props,
  S,
  SS
> {
  getProposalSenttDataApiCallId: string = "";
  sendReminderEmailApiCallIdForProposalPage: string = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.AlertMessage),
      // Customizable Area End
    ];

    this.state = {
      token: "",
      accountId: "",
      lineChartData: {
        labels: [],
        datasets: [],
      },
      clientList: [],
      proposalPackagePending: [],
      proposalsSentTimePeriod: 12,
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.RestAPIResponceMessage)) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.getProposalSenttDataApiCallId) {
        this.handleDashboardResponse(responseJson);
      } else if (this.sendReminderEmailApiCallIdForProposalPage == apiRequestCallId) {
        this.handleReminderEmailResponse(responseJson);
      }
    } else if (getName(MessageEnum.AlertMessage) === message.id) {
      const AlertBodyMessage = message.getData(
        getName(MessageEnum.AlertBodyMessage)
      );
      const msg = await this.props.showAlert({
        title: "Error",
        message: AlertBodyMessage,
      });
    }
  }
  handleDashboardResponse = (responseJson) => {
    this.props.hideLoader();
    if (
      responseJson?.monthly_count_logs ||
      responseJson?.count_by_ci ||
      responseJson?.pending_enrollment
    ) {
      const is_monthly_count_logs =
        Object.keys(responseJson?.monthly_count_logs).length > 0;
      const is_count_by_ci = responseJson?.count_by_ci && responseJson?.count_by_ci.length > 0;
      if (is_monthly_count_logs) {
        const labels = Object.keys(responseJson?.monthly_count_logs)?.reverse();

        const lineChartData = {
          labels,
          datasets:
            Object.values(responseJson?.monthly_count_logs)?.length > 0
              ? [
                  {
                    label: "",
                    data: Object.values(
                      responseJson?.monthly_count_logs
                    )?.reverse(),
                    borderColor: "#9CBE6A",
                    backgroundColor: "rgba(54, 162, 235, 1)",
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    pointHoverRadius: 4,
                    datalabels: {
                      align: "start",
                      anchor: "center",
                      font: {
                        family: "Nunito Sans",
                        size: 10,
                        weight: 500,
                      },
                      padding: 4,
                    },
                  },
                ]
              : [],
        };
        this.setState({
          lineChartData: lineChartData,
        });
      }
      if (is_count_by_ci) {
        const clientList = [];
        responseJson?.count_by_ci?.forEach((client) => {
          if (client) {
            const newClinet = {};
            newClinet.name = Object.keys(client)[0];
            newClinet.count = Object.values(client)[0][0];
            newClinet.date = Object.values(client)[0][1];
            newClinet.obsData = client.onboarding_survey;
            clientList.push(newClinet);
          }
        });
        this.setState({
          clientList: clientList,
        });
      }
      this.pendingEnrollment(responseJson)
    } else {
      this.handleApiErrorResponse(responseJson);
    }
  };
  pendingEnrollment = (responseJson) => {
    if (responseJson?.pending_enrollment) {
      this.setState({
        proposalPackagePending: Object.keys(
          responseJson?.pending_enrollment
        ).map((pkg) => {
          return {
            name: pkg,
            count: responseJson?.pending_enrollment[pkg],
          };
        }),
      });
    }
  }
  handleReminderEmailResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson?.message) {
      this.props.showToast({
        type: "success",
        message: "Reminder sent successfully",
      });
    } else {
      this.handleApiErrorResponse(responseJson);
    }
  };
  handleApiErrorResponse = (responseJson) => {
    if (typeof responseJson?.errors === "string") {
      this.props.showToast({
        type: "error",
        message: responseJson.errors,
      });
    } else {
      this.parseApiErrorResponse(responseJson);
    }
  };

  getProposalSenttData = () => {
    this.props.showLoader();
    const headers = {
      "content-type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getProposalSenttDataApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_informations/proposal_sent?last_month=${this.state.proposalsSentTimePeriod}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  sendReminderEmail = (survey_id, package_management_id, client_id) => {
    this.props.showLoader();

    const headers = {
      "content-type": "application/json",
      token: this.state.token,
    };

    const httpBody = {
      id: client_id,
      onboarding_link: `${window.location.origin}/onboardingSurveyLandingPage?survey_id=${survey_id}&package_management_id=${package_management_id}&client_id=${client_id}&account_id=${
        this.state.accountId
      }&selected_package_id=${package_management_id}&allow_to_change_package_id=${false}`,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.sendReminderEmailApiCallIdForProposalPage = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_clients/client_informations/proposal_pending_remainder`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
}
